// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_WIX","cls2":"ChatInterface-cls2_I1A ChatInterface-cls1_WIX"};